import { errorSnackbar } from "lib/snackbar/error-snackbar"
import { useState } from "react"
import { ReasonInput } from "./reason-input"
import { successSnackbar } from "lib/snackbar/success-snackbar"
import { useBoundContext } from "lib/@components/binding/use-bound-context"

export function EditAuditReason({
    value,
    setValue,
    label,
    disabled,
    tailoringAudit,
    hasExistingReason,
    onBuildAudit,
    onUpdateExisting,
    onCreate,
    dataCy,
    type,
}) {
    const [saving, setSaving] = useState(false)
    // Optional override bound by the audit hosts (TailoredAudit / TailoredTabTaskAudit / intro body).
    // The reason/rejection mutations return the stored Audit; pushing it here makes the saved value
    // display immediately instead of after the multi-second invalidation refetch (FIQ-682).
    const { setTailoringAudit } = useBoundContext()

    return (
        <ReasonInput
            value={value}
            setValue={setValue}
            label={label}
            disabled={disabled || saving}
            onSave={handleSave}
            dataCy={dataCy}
        />
    )

    async function handleSave(input) {
        if (!input?.reason) return

        try {
            setSaving(true)

            let saved
            if (tailoringAudit?.id) {
                saved = await onUpdateExisting(tailoringAudit.id, input.reason)
            } else {
                const audit = onBuildAudit(input.reason)
                saved = await onCreate(audit)
            }
            if (saved && typeof saved === "object") {
                setTailoringAudit?.(saved)
            }
            successSnackbar(`Successfully ${hasExistingReason ? "updated" : "created"} ${type}`)

            setValue(null)
        } catch {
            errorSnackbar(`Error saving ${type}`)
        } finally {
            setSaving(false)
        }
    }
}
